import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { Button, Card, Stack } from "@salesapp/ui";
import { billingApi } from "../lib/billingApi";
import { ThemeToggle } from "../shell/ThemeToggle";
import "./pages.css";

export function SsoCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const code = params.get("code") ?? "";
  const state = params.get("state") ?? "";
  const idpError = params.get("error");
  const [error, setError] = useState<string | null>(
    idpError ? "SSO sign-in could not be completed." : null,
  );

  const started = useRef(false);

  useEffect(() => {
    if (started.current || idpError || !code || !state) return;
    started.current = true;
    void billingApi.ssoOidcCallback(code, state).then(() => {
      navigate("/dashboard", { replace: true });
    }).catch(() => {
      setError("SSO sign-in could not be completed.");
    });
  }, [code, state, idpError, navigate]);

  return (
    <div className="login-page-frame">
      <ThemeToggle />
      <Card padding="lg" className="login-card">
        <Stack gap={4}>
          <h1 className="home-title">Signing in</h1>
          <p className="home-subtitle">
            {error
              ? "The identity provider could not finish this sign-in."
              : "Finishing single sign-on…"}
          </p>
          {error && <p className="crm-error" role="alert">{error}</p>}
          {error ? (
            <Button onClick={() => navigate("/login", { replace: true })}>Back to sign in</Button>
          ) : null}
        </Stack>
      </Card>
    </div>
  );
}
